export default __webpack_public_path__ + "static/media/icon-like-active.8eb04f91.svg";